<template>
  <div class="container-fluid" id="debt">
    <Navigation></Navigation>
    <div class="row wrapper">
      <div class="col-12 col-md-4 side-banner">
        <div class="header">
          <!-- <div id="steps" class="steps" tabindex="0" role="document">
            <span>Step 2</span> of 7
          </div> -->
          <div class="company-logo"></div>
          <h1 tabindex="0">Financial commitments and debt</h1>
          <div class="hero-image" alt="Financial commitments an debts"></div>
        </div>
      </div>
      <div class="col-12 col-md-8 main-banner">
        <div class="main">
          <h2>Your financial commitments</h2>
          <!-- <p>{{pageContent.pages.debt.financialCommitmentsText}}</p> -->
          <ValidationObserver v-slot="{ valid }" ref="form">
            <form @submit.prevent="onSubmit" @keydown.enter="$event.preventDefault()">

              <div class="form-group">
                <label tabindex="0">Your living situation</label>
                <br>
                <ValidationProvider name="mortgage" :rules="'required:'+pageContent.pages.debt.homeTypeRequiredErrorMessage" v-slot="{ errors }">
                  <div class="btn-radio-square">
                    <input tabindex="0" type="radio" id="mortgage" name="homeType" v-model="data.stepData.homeType" :value="Enum.homeType.MORTGAGE" @click="triggerHeightCheck()" data-analytics-capture-value="true">
                    <label for="mortgage">
                      <i class="icon mortgage"></i>
                      <span v-html="pageContent.pages.debt.mortgageButton"></span>
                    </label>
                  </div>
                  <div class="btn-radio-square">
                    <input tabindex="0" type="radio" id="rent" name="homeType" v-model="data.stepData.homeType" :value="Enum.homeType.RENT" @click="triggerHeightCheck()" data-analytics-capture-value="true">
                    <label for="rent">
                      <i class="icon rent"></i>
                      <span v-html="pageContent.pages.debt.rentButton"></span>
                    </label>
                  </div>
                  <div class="btn-radio-square-stretch">
                    <input tabindex="0" type="radio" id="none" name="homeType" v-model="data.stepData.homeType" :value="Enum.homeType.NONE" @click="triggerHeightCheck()" data-analytics-capture-value="true">
                    <label for="none">
                      <span v-html="pageContent.pages.debt.noMortgageNoRentButton"></span>
                    </label>
                  </div>
                  <span role="alert" class="form-text" v-bind:class="{ 'text-error': errors.length > 0 }">{{ errors[0] }}</span>
                </ValidationProvider>

              </div>

              <div class="form-group">
                <div v-if="data.stepData.homeType === Enum.homeType.RENT && data.stepData.familyType != Enum.familyType.SINGLE">
                  <ValidationProvider mode="lazy" name="rentAmount" :rules="'required:'+pageContent.pages.debt.rentError+'|between:'+config.fields.rentAmount.min+','+config.fields.rentAmount.max+','+pageContent.pages.debt.rentError" v-slot="{ errors }">
                    <label for="rentAmount" tabindex="0">
                      Your rent per week
                      <b-button id="tooltip-rentAmount" variant="tooltip" aria-label="tooltip rent amount"><i class="icon-help"></i></b-button>
                      <b-tooltip target="tooltip-rentAmount" placement="top">
                        Your death cover may cover the rent expenses of your beneficiaries. You can change the rental period using the edit assumptions link below.
                      </b-tooltip>
                    </label>
                    <!-- step question  -->
                    <cleave
                      data-analytics-capture-value="true"
                      :options="formatOptions.moneys"
                      class="form-control"
                      id="rentAmount"
                      name="rentAmount"
                      v-model.number="data.stepData.rentAmount"
                      :value="data.stepData.rentAmount"
                      v-on:blur="triggerHeightCheck"
                      type="text"
                      tabindex="0">
                    </cleave>
                    <span role="alert" class="form-text" v-bind:class="{ 'text-error': errors.length > 0 }" v-html="errors[0]"></span>
                  </ValidationProvider>
                </div>
                <div v-if="data.stepData.homeType === Enum.homeType.RENT && data.stepData.familyType === Enum.familyType.SINGLE">
                  <div class="info-box">
                    <div class="form-row">
                      <div class="col-1 icon"><i class="icon-info"></i></div>
                      <div class="col text" v-html="pageContent.pages.debt.singleRentInfoMessage"></div>
                    </div>
                  </div>
                </div>
                <div v-if="data.stepData.homeType === Enum.homeType.MORTGAGE">
                  <ValidationProvider mode="lazy" name="mortgageAmount" :rules="'required:'+pageContent.pages.debt.mortgageError+'|between:'+config.fields.mortgageAmount.min+','+config.fields.mortgageAmount.max+','+pageContent.pages.debt.mortgageError" v-slot="{ errors }">
                    <label for="mortgageAmount" tabindex="0">
                      How much do you owe on your home?
                      <b-button id="tooltip-mortgageAmount" variant="tooltip" aria-label="tooltip mortgage amount"><i class="icon-help"></i></b-button>
                      <b-tooltip target="tooltip-mortgageAmount" placement="top">
                        Death cover may be used to help pay off your mortgage.
                      </b-tooltip>
                    </label>
                    <!-- step question  -->
                    <cleave
                      data-analytics-capture-value="true"
                      :options="formatOptions.moneys"
                      class="form-control"
                      id="mortgageAmount"
                      name="mortgageAmount"
                      v-model.number="data.stepData.mortgageAmount"
                      :value="data.stepData.mortgageAmount"
                      v-on:blur="triggerHeightCheck"
                      type="text"
                      tabindex="0">
                    </cleave>
                    <span role="alert" class="form-text" v-bind:class="{ 'text-error': errors.length > 0 }" v-html="errors[0]"></span>
                  </ValidationProvider>
                </div>
              </div>

              <h2 class="mt-5">Your debt</h2>
              <p v-if="data.stepData.homeType == Enum.homeType.MORTGAGE">(Excluding mortgage)</p>
              <p>{{pageContent.pages.debt.yourDebtText}}</p>

              <div class="form-group max">
                <div class="form-row">
                  <div class="col">
                    <label tabindex="0">Type of debt</label><br/>
                  </div>
                  <div class="col">
                    <label tabindex="0">Amount</label><br/>
                  </div>
                </div>

                <!-- debts -->
                <div class="form-row repeat-input" v-for="(debt, ind) in debts" :key="ind">
                  <div class="col">
                    <select class="form-control" aria-label="Default select example" v-model="debt.Name" tabindex="0"
                      @change="!debt.Name && (debt.Amount = null)">
                      <option selected disabled value="">Select debt</option>
                      <option v-for="(confDebt, indd) in config.debts" :key="indd" :value="confDebt.value">{{confDebt.label}}</option>
                    </select>
                  </div>
                  <div class="col">
                    <ValidationProvider mode="lazy" :name="'debt_'+ind" :skip-if-empty="!debt.Name" :rules="'between:'+config.fields.debts.min+','+config.fields.debts.max+','+pageContent.pages.debt.debtRangeErrorMessage" v-slot="{ errors }">
                      <cleave
                        data-analytics-capture-value="true"
                        :class="{'is-muted': !debt.Name}"
                        :options="formatOptions.moneys"
                        class="form-control pre-remove-btn"
                        :id="'debt_'+ind"
                        v-model.number="debt.Amount"
                        type="text"
                        :aria-label="'debt amount '+ind"
                        v-on:blur="countDebt(); triggerHeightCheck()"
                        tabindex="0">
                      </cleave>
                      <button v-if="ind != 0 || debt.Name" class="remove-item-btn" v-on:click="removeDebt(ind)" tabindex="0" type="button" role="button"><i class="icon-remove" aria-label="Remove debt"></i></button>
                      <br/><span role="alert" class="form-text" v-bind:class="{ 'text-error': errors.length > 0 }" v-html="errors[0]"></span>
                    </ValidationProvider>
                  </div>
                </div>

                <button class="add-button" v-on:click="addDebt" tabindex="0" type="button" role="button">+ Add debt</button>
                <hr>
                <span v-html="pageContent.pages.debt.addedDebtLabel"></span>
                <h5>${{formatCurrency(totalDebtAmount, true)}}</h5>
                <span v-if="!totalDebtAmountValid" role="alert" class="form-text text-error" v-html="pageContent.pages.debt.debtTotalErrorMessage"></span>
              </div>

              <div class="nav-button row">
                <router-link class="assumption-button col" :to="{ name: 'Assumptions', params: {activeTab: 'assumptions' } }" tabindex="0" role="button"><i class="icon-edit"></i> Edit assumptions </router-link>
                <router-link class="back-button col" to="/about" tabindex="0" role="button">Back</router-link>
                <button class="next-button col" v-bind:class="[valid && totalDebtAmountValid ? 'is-active' : 'is-disabled']"  type="submit" tabindex="0" role="button">Next</button>
              </div>
            </form>
          </ValidationObserver>
        </div>

      </div>

    </div>
    <CustomFooter></CustomFooter>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapFields } from "vuex-map-fields";
import Cleave from "vue-cleave-component";
import CustomFooter from '../components/CustomFooter';
import Navigation from '../components/Navigation';

import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import { required, between } from 'vee-validate/dist/rules';

import _ from 'lodash';

extend('required', {
  ...required,
  params: ['msg'],
  message: '{msg}'
});
extend('between', {
  ...between,
  params: ['min', 'max', 'msg'],
  validate(value, { min, max }) {
    return value >= min && value <= max;
  },
  message: '{msg}'
});

export default {
  name: 'Debt',
  components: { Cleave, ValidationProvider, ValidationObserver, CustomFooter, Navigation },
  computed: {
    ...mapFields(["debts", "data", "prevTab"]),
    ...mapGetters(["Enum", "config", "formatOptions", "pageContent"]),
    totalDebtAmountValid() {
      return this.totalDebtAmount <= this.config.fields.debts.max;
    },
  },
  methods: {
    toggleHomeTypeBtn() {
      this.triggerHeightCheck();
    },
    addDebt() {
      this.debts.push({"Name":'', "Amount":null, "Error": false});
      this.countDebt();
      this.triggerHeightCheck();
    },
    removeDebt(ind) {
      if(this.debts.length > 1) {
        this.debts.splice(ind, 1);
      }
      else {
        this.debts.pop();
        this.debts.push({"Name":'', "Amount":null, "Error": false});
      }
      this.countDebt();
      this.triggerHeightCheck();
    },
    countDebt() {
      this.totalDebtAmount = 0;
      this.debts.filter(d => d.Amount).forEach(debt => {
        this.totalDebtAmount += debt.Amount;
      });
    },
    formatCurrency: (value, noCents = false) => {
      return value === null
        ? ""
        : noCents
        ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        : parseFloat(value)
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    triggerHeightCheck: function() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 300);
    },
    onSubmit () {
      this.$refs.form.validateWithInfo().then(result => {
        if (!result.isValid) {
          var fieldArr = _.valuesIn(result.fields);
          var firstError = document.getElementById(fieldArr[0].id)
          if(firstError) {
            firstError.scrollIntoView({behavior: 'smooth'});
          }
          this.triggerHeightCheck();
          return;
        }
        if(!this.totalDebtAmountValid) return;
        this.prevTab = 2;
        this.$router.push('/income');
      });
    },
  },
  mounted() {
    //load defaults
    this.countDebt();
    this.triggerHeightCheck();
    this.$scrollIframeTop();
    window.addEventListener("resize", this.$refreshIframeHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.$refreshIframeHeight);
  },
  beforeDestroy() {
    // send analytics - complete form step
    var dataObj = {
      "homeType": this.data.stepData.homeType,
      "mortgageAmount": this.data.stepData.mortgageAmount,
      "rentAmount": this.data.stepData.rentAmount,
      "debts": []
    };
    if(this.data.stepData.homeType === this.Enum.homeType.MORTGAGE) {
      dataObj.rentAmount = 0;
    }
    else if(this.data.stepData.homeType === this.Enum.homeType.RENT) {
      dataObj.mortgageAmount = 0;
    }
    else {
      dataObj.rentAmount = 0;
      dataObj.mortgageAmount = 0;
    }
    this.debts.forEach(debt => {
      var newDebt = {"Name": debt.Name, "Amount": debt.Amount};
      dataObj.debts.push(newDebt);
    });
    this.$gtag.event('step-debt', { event_category: 'form-step-progress', event_label: JSON.stringify(dataObj) });

    // clear any debt errors when moving step. should not be any errors.
    // Was showing error if you went to next step and back to debt step.
    this.debts.forEach(debt => {
      debt.Error = false;
    });
  },
  data() {
    return {
      totalDebtAmount: 0,
    };
  }
}

</script>
